export namespace ContentPagesStore {
  export enum ENDPOINTS {
    ENDPOINT = 'endpoint',
    MAIN_PAGE = 'page/24',
    PATH_PAGE = 'theme',
    ABOUT_PAGE = 'page/45',
    DETAIL_PAGE = 'film',
    PATH_OVERVIEW_PAGE = 'page/48',
  }
}
